import React from 'react'
import PropTypes from 'prop-types'
import strings from 'utils/strings'
import { COMPONENT, DASH_VIEW } from 'utils/constants'
import { DEFAULT_DRAWER_WIDTH } from 'utils/drawerConstants'
import { useDispatch } from 'react-redux'
import { setDrawerVisibleWidth, setDrawerWidth } from 'actions/drawer'
import { setSelectedIdWithDrawerAndMeta } from 'actions/navigator'
import { StyledTableButton, StyledEmpty } from '../PartTableView.style'

const TablePart = ({ disableOnClick, defaultDrawerWidth, tablePart }) => {
  // since builders can't dnd, ok to use actual list location since parts don't change locations
  const { location, panelDescription, dashObjectDescription } = tablePart
  const description =
    panelDescription || dashObjectDescription || strings.no_data

  const dispatch = useDispatch()

  const handleOnClick = () => {
    if (disableOnClick) return

    if (!defaultDrawerWidth) {
      dispatch(setDrawerWidth(DEFAULT_DRAWER_WIDTH))
      dispatch(setDrawerVisibleWidth(DEFAULT_DRAWER_WIDTH))
    }

    dispatch(
      setSelectedIdWithDrawerAndMeta(DASH_VIEW, {
        view: COMPONENT,
        id: location,
      })
    )
  }

  return (
    <>
      {description === strings.no_data ? (
        <StyledEmpty defaultDrawerWidth={defaultDrawerWidth}>
          {strings.no_data}
        </StyledEmpty>
      ) : (
        <StyledTableButton
          link
          onClick={handleOnClick}
          defaultDrawerWidth={defaultDrawerWidth}
        >
          {description}
        </StyledTableButton>
      )}
    </>
  )
}

TablePart.propTypes = {
  tablePart: PropTypes.object,
  panelDescription: PropTypes.string,
  panelNumber: PropTypes.string,
  onClick: PropTypes.func,
  disableOnClick: PropTypes.func,
  listLocation: PropTypes.string,
  switchId: PropTypes.string,
  defaultDrawerWidth: PropTypes.bool,
}

export default TablePart
